module.exports = __webpack_public_path__ + "static/media/kizuna-theme.46944dd2.wav";